module.exports = {
	"description": "ThemeProvider passes along a theme to its children.",
	"methods": [],
	"props": {
		"children": {
			"flowType": {
				"name": "React$Node"
			},
			"required": false,
			"description": "Components to which the theme will be applied"
		},
		"theme": {
			"flowType": {
				"name": "Object"
			},
			"required": false,
			"description": "A shallow object of [theme variables](/theming/#theming-theme-variables) and their values",
			"defaultValue": {
				"value": "mineralTheme",
				"computed": true
			}
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-docgen-loader!./src/themes/ThemeProvider.js
// module id = 1699
// module chunks = 0